import VGDropdown from "../../../../../modules/vegas/js/dropdown";
import {listener, findAll, onReady} from "../../../../../modules/vegas/js/util";
import VGCatalogCategories from "./categories";
import CategoryNav from "./categories-nav";
import {VGSidebar} from "vgsidebar";

[...findAll('[data-vg-toggle="dropdown"]')].forEach((el) => {
	el.onclick = function () {
		let dropdown = new VGDropdown(this.dataset.target, {
			button: this
		});

		dropdown.toggle();

		return false;
	}
})

listener('vg.dropdown.show', '#catalog-categories-dropdown', function (el, e) {
	e.preventDefault();

	new VGCatalogCategories(el, {}).init();
});

/** categories nav */
onReady(() => {
	let categoryNavElement = document.getElementById('categories-nav-container');
	if (categoryNavElement) {
		window.categoryNav = new CategoryNav(categoryNavElement);
	}
});

listener('click', '.categories-nav .back a', (a, e) => {
	const parentId = a.closest('li').dataset.id;
	if (parentId) {
		window.categoryNav?.toBack(parentId);
	} else {
		window.categoryNav?.toMain();
	}
}, true);

listener('click', '.categories-nav .category a', (a, e) => {
	const categoryId = a.closest('li').dataset.id;
	window.categoryNav?.toCategory(categoryId);
}, true);


listener('click', '.categories-nav .view-all a', (a, e) => {
	if (!document.getElementById('catalog-products')) {
		location.href = a.href;
	} else {
		window.categoryNav?.toCategory(a.closest('li').dataset.id);
		VGSidebar.getInstance('#sidebar-catalog').hide();
	}
}, true);
